import { Component, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { FormGroup, FormBuilder} from '@angular/forms';
import { ListRisksMatrix, ViewRisk, BasicList, User, ListDependence, ListAssigned } from '../../../interfaces/project/list/projectDetailsDto';
import { NgbModalConfig, NgbModal, ModalDismissReasons, NgbCalendar, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ErrorService } from 'src/app/shared/services/errors.service';

@Component({
  selector: 'app-edit-detail-project',
  templateUrl: './edit-detail-project.component.html',
  styleUrls: ['./edit-detail-project.component.scss']
})
export class EditDetailProjectComponent implements OnInit {


  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  closeResult = ''
  model2: string
  item: ListRisksMatrix
  type: string;
  edit: boolean;
  create: boolean;
  itemName: string;
  projectId: number;

  viewRisk: ViewRisk = {} as ViewRisk;
  selectedDependence
  probabilityName = 0;
  listAssigned: []

  constructor(
    private spinner: NgxSpinnerService,
    private config: NgbModalConfig,
    private modalService: NgbModal,
    private apiService: ApiServiceProject,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<string>,
    private errorService:ErrorService

  ) {

  }

  riskForm: FormGroup = this.fb.group({
    dependence: {},    
    name: [''],
    description: [''],
    dateStart: [''],
    dateEnd: [''],
    process: [''],
    probability: [''],
    impact: [''],
    impactDescription: [''],
    assigned: []
  })



  ngOnInit(): void {
   
  }

  serviceInfo(type: string, risk: ListRisksMatrix){
    this.spinner.show()
    this.activatedRoute.params.subscribe(params => {
      return this.projectId = params['id'];
    })
    this.spinner.show()
    this.apiService.getService(`project-view-risks?id_project=${this.projectId}`).subscribe({
      next(data) {
        if (data) {
          this.viewRisk = data
          for (const key in data.listAssigned) {
            if (Object.prototype.hasOwnProperty.call(data.listAssigned, key)) {
              const element = data.listAssigned[key];
            }
          }
          this.dateIn(type,risk)
        }
        else {
          this.spinner.hide()
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })
  }

  dateIn(type: string, risk: ListRisksMatrix){
    switch (type) {
      case 'editRisk':
        this.item = risk
        this.type = type
        this.edit = true
        this.itemName = 'Riesgo'
        this.setFormValues(risk)
        break;
      case 'createRisk':
        this.type = type
        this.edit = false
        this.itemName = 'Riesgo'

        break;
      default:
        this.type = type
        this.edit = false
        this.itemName = 'Riesgo'

        break;

    }
  }

  public open(
    risk: ListRisksMatrix,
    type: string,
  ) {
    this.serviceInfo(type, risk);

    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    })
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  setFormValues(risk) {
    this.riskForm.patchValue({
      name: [risk.name],
      description: [risk.description],
      dateStart: [risk.dateStart],
      dateEnd: [risk.dateEnd],
      probability: [],
      impact: [risk.impact],
      assigned: [''],
      process: [risk.process],
      impactDescription: [risk.impactDescription],

    })
  }

  validField(field, form) {
    return form.controls[field].errors
      && form.controls[field].touched;
  }

  clearForm() {
    this.riskForm.reset()
    this.type = ''
  }



}

